import React from "react";

export default function SuccessBlock(props: { successText: string }) {
  return <div className="js-successbox t-form__successbox t-text t-text_md" aria-live="polite"
              style={ { display: "block" } }>{ props.successText }</div>
}